import { defaultFetch } from './baseApi';

export type ProjectAggregateStatisticsType = {
	advanceCashedIn: number;
	cashedIn: number;
	checkAssignedCompleted: number;
	checkCompleted: number;
	checkCompletedWithErrors: number;
	completedAmount: number;
	compliantAmount: number;
	errorAmount: number;
	finalAmount: number;
	inProgressAmount: number;
	notCompliantAmount: number;
	percentageAmountError: number;
	percentageAssignedCompleted: number;
	percentageCompleted: number;
	percentageCompletedWithErrors: number;
	reportedAmount: number;
	reportedIndirectCost: number;
	requestedAmount: number;
	sampledTotalAmount: number;
	selfFinancedAmount: number;
	totalAmount: number;
	totalApprovedAmount: number;
	totalAssignedInvoices: number;
	totalInvoices: number;
};

export const getProjectAggregateStatistics = (aggregateId: string, queryParams = '') => {
	return defaultFetch<ProjectAggregateStatisticsType>(`/v0/projectaggregates/${aggregateId}/stats${queryParams}`);
};

export const getSalOptions = (aggregateId: string) => {
	return defaultFetch<string[]>(`/v0/projectaggregates/${aggregateId}/sals`);
};
